import { render, staticRenderFns } from "./DiscountByPercentage.vue?vue&type=template&id=86d9fb00&scoped=true&"
import script from "./DiscountByPercentage.vue?vue&type=script&lang=ts&"
export * from "./DiscountByPercentage.vue?vue&type=script&lang=ts&"
import style0 from "./DiscountByPercentage.vue?vue&type=style&index=0&id=86d9fb00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d9fb00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
